<script>
  import { onDestroy } from 'svelte';
  import Button from '@components/Button.svelte';
  import { getCurrentUserStore } from '@stores/current_user';
  import UserAccountFlagAjax from '@ajax/user_account_flag';

  import { getProfileStore } from '@stores/profile';
  let linktreePromptStore = getProfileStore('linktreePromptStore');
  import loadLinktree from '@utils/linktree';
  import { fade } from 'svelte/transition';

  let currentUser = getCurrentUserStore('default');
  let show = false;
  let unsubLinktreeShow = linktreePromptStore.subscribe((x) => {
    show = x.banner;
    if (show) {
      loadLinktree(currentUser.profile_path, 'benable_banner', '#linktree-banner-button');
    }
  });

  onDestroy(async () => {
    unsubLinktreeShow();
  });

  let elem;

  let handleClick = function () {
    UserAccountFlagAjax.flagLinktreeProfilePromptClicked();
    linktreePromptStore.set({
      banner: false,
      social: false,
    });
    elem.querySelector('button').click();
  };

  let handleClose = function () {
    UserAccountFlagAjax.flagLinktreeProfileBannerClosed();
    linktreePromptStore.set({
      banner: false,
      social: linktreePromptStore.social,
    });
  };
</script>

<style style="text/scss" lang="scss">
  @import '../../vendor/design-system.scss';

  .banner {
    width: 100%;
    height: 64px;
    overflow: hidden;
    position: relative;
    background-size: cover;
    background: $purple-30;

    .text-button-container {
      display: flex;
      width: 100%;
      height: 100%;
      align-items: center;

      .text-container {
        display: flex;
        flex: 1;
        padding-left: 45px;

        .main-text {
          font-weight: 500;
          font-size: 14px;
          line-height: 20px;
          opacity: 0.8;
        }

        .sub-text {
          opacity: 0.8;
          color: #665e83;
          font-size: 14px;
          line-height: 18px;
          margin-left: 4px;
          margin-top: 1px;
        }

        .mobile-only {
          display: none;
        }
      }

      .button-container {
        flex-shrink: 0;
        margin-top: -3px;
        padding-right: 60px;

        :global(button > span) {
          margin-top: -1px;
        }
      }
    }
  }

  @media only screen and (max-width: 680px) {
    .banner {
      height: unset !important;
      padding-top: 20px;
      padding-bottom: 20px;
    }

    .text-button-container {
      flex-direction: column;
      align-items: flex-start !important;
      padding-left: 30px;
      padding-right: 30px;
    }

    .text-container {
      padding-left: 0px !important;
      padding-right: 20px !important;
    }

    .button-container {
      padding-right: 0px;
      padding-left: 0px;
      margin-bottom: -7px;
      margin-top: 5px !important;

      :global(button) {
        width: unset !important;
        padding-left: 24px;
        padding-right: 24px;
      }
    }
  }

  @media only screen and (max-width: 1280px) {
    .sub-text {
      display: none;
    }

    .mobile-only {
      display: inline !important;
    }
  }

  .close-button {
    cursor: pointer;
    position: absolute;
    right: 20px;
    top: 20px;
    .close-path {
      fill: $neutral-gray;
    }
  }
</style>

<div id="linktree-banner-button" bind:this={elem} style="display: none" />

{#if currentUser && currentUser.id && show}
  <div class="banner" out:fade={{ duration: 200 }}>
    <div class="text-button-container">
      <div class="text-container">
        <div class="main-text">Add your Benable profile to your Linktree<span class="mobile-only">!</span></div>

        <div class="sub-text">so your followers can easily find your recommendations!</div>
      </div>

      <div class="button-container">
        <Button
          on:click={handleClick}
          colorScheme="black"
          size="large"
          style={'font-weight: 600;  padding: 0px 20px; height: 40px; border-radius: 12px;'}>
          <svg
            class="linktree-button-icon"
            style="margin-right: 10px"
            viewBox="0 0 96 97"
            fill="none"
            width="16"
            height="16"
            ><path
              d="M54.0359 23.4137L70.0559 6.9457L79.3541 16.468L62.55 32.4879H86.1878V45.7072H62.438L79.3541 62.1379L70.0559 71.4735L47.0902 48.3958L24.1246 71.4735L14.8263 62.1752L31.7425 45.7445H7.99268V32.4879H31.6305L14.8263 16.468L24.1246 6.9457L40.1445 23.4137V0H54.0359V23.4137ZM40.1445 64.6398H54.0359V96.0075H40.1445V64.6398Z"
              fill="#fff" /></svg>

          Add Benable to my Linktree
        </Button>
      </div>

      <div class="close-button" on:click={handleClose}>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            class="close-path"
            d="M7.14978 6.08842C7.13814 6.07681 7.1289 6.06302 7.1226 6.04783C7.1163 6.03265 7.11305 6.01637 7.11305 5.99993C7.11305 5.98349 7.1163 5.96721 7.1226 5.95202C7.1289 5.93683 7.13814 5.92304 7.14978 5.91143L11.7811 1.28062C11.9217 1.13979 12.0006 0.948872 12.0005 0.749857C12.0004 0.550842 11.9212 0.360034 11.7803 0.219408C11.6395 0.0787831 11.4486 -0.000140457 11.2496 1.87653e-07C11.0506 0.000140832 10.8598 0.0793341 10.7191 0.220158L6.08832 4.84897C6.07671 4.86061 6.06292 4.86985 6.04773 4.87615C6.03254 4.88245 6.01626 4.8857 5.99982 4.8857C5.98338 4.8857 5.9671 4.88245 5.95192 4.87615C5.93673 4.86985 5.92294 4.86061 5.91133 4.84897L1.28051 0.220158C1.21088 0.150495 1.12821 0.0952284 1.03722 0.0575143C0.946233 0.0198001 0.848706 0.000376929 0.75021 0.000353716C0.551289 0.000306834 0.360496 0.079283 0.219805 0.219908C0.079113 0.360534 4.69031e-05 0.551289 2.08609e-08 0.75021C-4.68614e-05 0.949132 0.0789293 1.13992 0.219555 1.28062L4.84987 5.91143C4.86151 5.92304 4.87074 5.93683 4.87705 5.95202C4.88335 5.96721 4.88659 5.98349 4.88659 5.99993C4.88659 6.01637 4.88335 6.03265 4.87705 6.04783C4.87074 6.06302 4.86151 6.07681 4.84987 6.08842L0.219555 10.7197C0.149924 10.7894 0.0946965 10.8721 0.0570253 10.9631C0.019354 11.0541 -2.31929e-05 11.1516 2.08609e-08 11.2501C4.69031e-05 11.4491 0.079113 11.6398 0.219805 11.7804C0.289468 11.8501 0.372164 11.9053 0.463171 11.943C0.554179 11.9806 0.651714 12 0.75021 12C0.949132 12 1.13989 11.9209 1.28051 11.7802L5.91133 7.14888C5.92294 7.13724 5.93673 7.12801 5.95192 7.1217C5.9671 7.1154 5.98338 7.11216 5.99982 7.11216C6.01626 7.11216 6.03254 7.1154 6.04773 7.1217C6.06292 7.12801 6.07671 7.13724 6.08832 7.14888L10.7191 11.7802C10.8598 11.9209 11.0505 12 11.2494 12C11.4484 12 11.6391 11.9211 11.7798 11.7804C11.9205 11.6398 11.9996 11.4491 11.9996 11.2501C11.9997 11.0512 11.9207 10.8604 11.7801 10.7197L7.14978 6.08842Z"
            fill="#AE94F9" />
        </svg>
      </div>
    </div>
  </div>
{/if}
